import { useState } from 'react';

import { AUTH_STORAGE_KEYS } from '../../../../auth/constants/auth.constants';
import { PAYMENT_TEXTS } from '../../../constants/payment.constants';

interface UseInvoicePaymentOptions {
    termsAccepted: boolean;
    onPayLater: (email: string) => void;
}

interface UseInvoicePaymentReturn {
    email: string;
    setEmail: (email: string) => void;
    validationError: string;
    setValidationError: (error: string) => void;
    handlePayLater: () => void;
    isEmailValid: (email: string) => boolean;
}

export const useInvoicePayment = ({
    termsAccepted,
    onPayLater,
}: UseInvoicePaymentOptions): UseInvoicePaymentReturn => {
    const [email, setEmail] = useState(() => localStorage.getItem(AUTH_STORAGE_KEYS.EMAIL) || '');
    const [validationError, setValidationError] = useState('');

    const isEmailValid = (email: string) => {
        const re = PAYMENT_TEXTS.INVOICE.EMAIL_REGEX;
        return re.test(email) && email.length <= 254;
    };

    const handlePayLater = () => {
        if (!termsAccepted) {
            setValidationError('Please accept the Terms & Conditions');
            return;
        }
        if (!email) {
            setValidationError('Recipient email is required');
            return;
        }
        if (!isEmailValid(email)) {
            setValidationError('Please enter a valid email address');
            return;
        }
        setValidationError('');
        onPayLater(email);
    };

    return { email, setEmail, validationError, setValidationError, handlePayLater, isEmailValid };
};
